import { QueryHookOptions } from '@apollo/client';
import { PaginationInfo, usePaginatedQuery } from '@occc-app/hooks/usePaginatedQuery';
import {
  GamesListQuery,
  GamesListQueryVariables,
  OfferFilter,
  useGamesListQuery,
} from '@occc/graphql';

type GetGamesListArgs = {
  filter: OfferFilter;
  pageSize?: number;
  baseOptions?: QueryHookOptions<GamesListQuery, GamesListQueryVariables>;
  paginationInfo?: PaginationInfo;
  onPageChange?: (info: PaginationInfo) => void;
};

export const useGetGamesList = ({
  filter,
  pageSize,
  baseOptions,
  paginationInfo,
  onPageChange,
}: GetGamesListArgs) => {
  const response = usePaginatedQuery(
    useGamesListQuery,
    'offers.pageInfo',
    pageSize,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      ...baseOptions,
      variables: {
        ...baseOptions?.variables,
        filter,
      },
    },
    paginationInfo,
    onPageChange,
  );

  return {
    ...response,
    data: response.data ? response.data.offers.edges.map((item) => item.node) : response.data,
  };
};
